import { combineReducers } from 'redux'
import * as ActionTypes from '../actions/actionTypes'

// page reducer
import place from '../containers/Place/reducer'
import food from '../containers/Food/reducer'
import otop from '../containers/Otop/reducer'
import news from '../containers/News/reducer'
import hotels from '../containers/Hotels/reducer'
import shopping from '../containers/Shopping/reducer'
import bookmark from '../containers/Bookmark/reducer'

// Updates error message to notify about the failed fetches.
const errorMessage = (state = null, action) => {
  const { type, error } = action

  if (type === ActionTypes.RESET_ERROR_MESSAGE) {
    return null
  } else if (error) {
    return error
  }
  return state
}

const languageReducer = (state = 'th', action) => {
  switch (action.type) {
    case ActionTypes.CHANGE_LAUGUAGE:
      return action.lang
    default:
      return state
  }
}

const areas = (state = [], action) => {
  switch (action.type) {
    case ActionTypes.AREAS.REQUEST:
    return []
  case ActionTypes.AREAS.SUCCESS:
    return action.data
  case ActionTypes.AREAS.FAILURE:
    return state
  default:
    return state
  }
}
const category = (state = [], action) => {
  switch (action.type) {
    case ActionTypes.CATEGORY.REQUEST:
    return []
  case ActionTypes.CATEGORY.SUCCESS:
    return action.data
  case ActionTypes.CATEGORY.FAILURE:
    return state
  default:
    return state
  }
}

const online = (state = true, action) => {
  switch (action.type) {
    case 'APP_STATE':
      return action.isOnline
    default:
      return state
  }
}

const lasted = (state = '', action) => {
  switch (action.type) {
    case ActionTypes.CHECK_LASTED.REQUEST:
      return state
    case ActionTypes.CHECK_LASTED.SUCCESS:
      return action.data
    case ActionTypes.CHECK_LASTED.FAILURE:
      return state
    default:
      return state
  }
}

const rootReducer = combineReducers({
  errorMessage,
  lang: languageReducer,
  place,
  food,
  otop,
  news,
  hotels,
  shopping,
  areas,
  category,
  online,
  lasted,
  bookmark
})

export default rootReducer


// WEBPACK FOOTER //
// ./src/reducers/reducers.js